import { fulfillmentApi } from '../../../api/fulfillmentApi';
import { createActivity, IActivity } from '../../../models/activities';
import { IEntityToDisable } from '../../../models/entityToDisable';
import { AppDispatch, RootState } from '../../store';
import { setActivities, setActivity, startLoadingActivities, updateActivities } from './activitiesSlice';

export const getActivities = () => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingActivities());
        const resp = await fulfillmentApi.get(`activities`);

        dispatch(setActivities({ activities: resp.data }));
    }
}

export const getActivity = (activityId: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingActivities());
        const resp = await fulfillmentApi.get(`activities/${activityId}`);

        dispatch(setActivity({ activity: resp.data }));
    }
}

export const saveActivity = (activity: IActivity) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingActivities());
        const newActivity = createActivity(activity);
        const resp = await fulfillmentApi.post(`activities`, newActivity);

        const state = getState();
        let activities = [...state.activities.activities];
        activities.push(resp.data);

        dispatch(setActivities({ activities }));
    }
}

export const editActivity = (activity: IActivity) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingActivities());

        await fulfillmentApi.put(`activities/${activity.id}`, activity);

        const resp = await fulfillmentApi.get(`activities/${activity.id}`);

        dispatch(setActivity({ activity: resp.data }));
        dispatch(updateActivities({ activity: resp.data }));
    }
}

export const disableActivity = (entityToDisable: IEntityToDisable) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingActivities());

        await fulfillmentApi.put(`activities/expire/${entityToDisable.id}`, entityToDisable);

        const resp = await fulfillmentApi.get(`activities/${entityToDisable.id}`);

        dispatch(setActivity({ activity: resp.data }));
        dispatch(updateActivities({ activity: resp.data }));
    }
}
